import { initializeFirebase } from '@/firebase/firebaseInit'

import loggerLocal from '@/utils/loggerLocal'

import { type UploadMetadata, deleteObject, getDownloadURL, getMetadata, ref, uploadBytes } from 'firebase/storage'

import { useStoreError } from '@/stores/storeError'
import { useStoreUser } from '@/stores/storeUser'

import { DBAttachmentType, DBModelOwner, DBMutationType, DBRetCode, DBStorageType } from '@functions/models/DBEnum'
import { GlbCompanyAuthCollectionName } from '@functions/models/GlbCostants'

import { i18nGlobal } from '@/i18n'
import { showErrorMessage } from '@/utils/showMessage'
import { currentTS } from '@/utils/utils'
import { type IntAttachmentData } from '@functions/models/interfaces/intAttachment'
import { type IOGetUploadUrlRequest } from '@functions/models/ioInterfaces/ioGetUploadUrl'
import { type IOListAttachmentRequest, type IOListAttachmentResponse } from '@functions/models/ioInterfaces/ioListAttachment'
import {
  type IOMutateAttachmentRequest,
  type IOMutateAttachmentResponse,
} from '@functions/models/ioInterfaces/ioMutateAttachment'
import { type IOSetAuthRequest } from '@functions/models/ioInterfaces/ioSetAuth'
import { doc, getDoc } from 'firebase/firestore'
import { getCurrentSession } from './auth'
import { be_getUploadUrl, be_listAttachment, be_mutateAttachment, be_setAuth } from './backEndCaller'

const firebase = await initializeFirebase()
const storageCompany = firebase.storageCompany
const storageDefault = firebase.storageDefault
const storageUser = firebase.storageUser
const storagePublic = firebase.storagePublic
const storageMisc = firebase.storageMisc
const companyCollectionRef = firebase.companyCollectionRef

async function uploadFileToStorage (
  file: File,
  path: string,
  storageType?: DBStorageType,
  modelOwner?: DBModelOwner,
  extraMetadata?: any,
): Promise<string | null> {
  loggerLocal.info( 'starting uploadFile' )
  const storeUser = useStoreUser()
  const timeS = currentTS()
  if ( !file || !( file instanceof File ) )
  {
    loggerLocal.info( 'file not present', file )
    return null
  }
  /*const resSheckAuth = await checkAuth()
  if ( !resSheckAuth )
  {
    loggerLocal.info( 'resSheckAuth', resSheckAuth )
    return null
  }*/
  loggerLocal.info( 'filePath', path )
  const filePath = !path.endsWith( '/' ) ? path + '/' : path

  const fileWithPath = ( filePath + timeS + file.name ).replace( / /g, '_' )

  loggerLocal.info( 'fileWithPath', fileWithPath )
  const storage =
    storageType == DBStorageType.USER
      ? storageUser
      : storageType == DBStorageType.COMPANY
        ? storageCompany
        : storageType == DBStorageType.PUBLIC
          ? storagePublic
          : storageType == DBStorageType.MISC
            ? storageMisc
            : storageDefault
  loggerLocal.info( 'fileWithPath', fileWithPath, 'storage', storage )
  const storageRef = ref( storage, fileWithPath )
  //console.log('storageRef', storageRef)
  loggerLocal.info( 'storageRef', storageRef )
  const metadata: UploadMetadata = {
    contentType: file.type,
    contentDisposition: 'inline; filename="' + file.name + '"',
    customMetadata: {
      originalName: file.name,
      userId: storeUser.userData?.id ?? '',
      idProvider: storeUser.userData?.idProvider ?? '',
      modelOwner: modelOwner ? modelOwner : DBModelOwner.NOTDEFINED,
      ...extraMetadata,
      // xxx: extraMetadata,
    },
  }
  //console.log('metadata', metadata)
  loggerLocal.info( 'metadata', metadata )
  try
  {
    const upload = await uploadBytes( storageRef, file, metadata )
    //console.log('upload', upload);
    loggerLocal.info( 'upload', upload )
    //const refFile = await getDownloadURL(storageRef)

    // const resDel = await deleteObject(storageRef)
    //console.log('refFile', refFile);
    //loggerLocal.info('refFile', refFile)

    // return refFile
    return fileWithPath
  } catch ( error )
  {
    //console.log('storage error', error)
    loggerLocal.error( 'storage error', error )
    const storeError = useStoreError()
    storeError.setError( i18nGlobal.t( 'error.storage' ), error )
    return null
  }
}

async function downloadThisFile ( fileUrl: string, fileName?: string, type?: string ) {
  //loggerLocal.info('downloadThisFile', fileUrl, fileName, type)
  /*const link = document.createElement('a')
    //if (typeof link.download === 'string') {
    //document.body.appendChild(link) // Firefox requires the link to be in the body
    link.href = fileUrl
    link.download = fileName || 'download'
    //Response.AddHeader('Content-disposition', 'attachment; filename=' + Name)
    //link.target = '_blank'
    //loggerLocal.info('link', link)
    //link.textContent = 'attachment'
    //link.contentEditable = 'attachment'

    link.click()
    //document.body.removeChild(link) // remove the link when done
    } else {
        location.replace(fileUrl)
    }
    return link*/

  const a = document.createElement( 'a' )
  //a.target = '_blank'
  a.href = fileUrl
  a.title = fileName || 'download'
  a.download = fileName || 'download'
  a.target = '_blank'
  const clickHandler = () => {
    setTimeout( () => {
      URL.revokeObjectURL( fileUrl )
      removeEventListener( 'click', clickHandler )
    }, 150 )
  }
  a.addEventListener( 'click', clickHandler, false )

  return a
}

export async function downloadFileFromStorage ( path: string, downloadIt: boolean ): Promise<string | null> {
  const storageRef = ref( storageDefault, path )
  try
  {
    const refFile = await getDownloadURL( storageRef )
    const metadata = await getMetadata( storageRef )
    if ( downloadIt )
    {
      /*const res = getDownloadURL(storageRef)
                .then(url => {
                    // `url` is the download URL for 'images/stars.jpg'

                    // This can be downloaded directly:
                    const xhr = new XMLHttpRequest()
                    //xhr.getRequestHeader('Content-Type', 'application/octet-stream')
                    xhr.responseType = 'blob'
                    xhr.onload = event => {
                        const blob = xhr.response
                    }
                    xhr.open('GET', url)
                    xhr.send()
                    return xhr.responseURL
                    // Or inserted into an <img> element
                    //const img = document.getElementById('myimg')
                    //img.setAttribute('src', url)
                })
                .catch(error => {
                    // Handle any errors
                    loggerLocal.error('downloadFileFromStorage error', error)
                })

            loggerLocal.info('res', res)*/

      const download = await downloadThisFile( refFile, metadata?.customMetadata?.originalName )
      download.click()
      //document.body.appendChild(download)
      //window.location.href = refFile
      //window.location.assign(refFile)
      //window.open(refFile)
    }
    return refFile
    //return 'ciao'
  } catch ( error )
  {
    loggerLocal.error( 'storage error', error )
    const storeError = useStoreError()
    storeError.setError( i18nGlobal.t( 'error.storage' ), error )
    return null
  }
}

export async function uploadProfileImage ( file: File, userId?: string ): Promise<string | null> {
  const storeUser = useStoreUser()
  const newUserId = userId ?? storeUser.userData?.id ?? ''
  const extraMetadata = {
    idUser: newUserId,
  }
  const path = 'public/user/' + newUserId + '/profileImage/'
  return await uploadFileToStorage( file, path, DBStorageType.USER, DBModelOwner.USER, extraMetadata )
}

export async function uploadCompanyImage ( file: File ): Promise<string | null> {
  const storeUser = useStoreUser()
  const companyId = storeUser.companyData?.id ?? ''
  const extraMetadata = {
    idCompany: companyId,
  }
  const path = 'public/company/' + companyId + '/companyImage/'
  return await uploadFileToStorage( file, path, DBStorageType.COMPANY, DBModelOwner.COMPANY, extraMetadata )
}

export async function uploadMiscImage ( file: File, mo: DBModelOwner, id: string ): Promise<string | null> {
  const storeUser = useStoreUser()
  const companyId = storeUser.companyData?.id ?? ''
  const extraMetadata = {
    idCompany: companyId,
    modelOwner: mo,
    id
  }
  const path = 'public/misc/' + mo + '/' + id + '/image/'
  return await uploadFileToStorage( file, path, DBStorageType.MISC, mo, extraMetadata )
}

export async function uploadMiscVideo ( file: File, mo: DBModelOwner, id: string ): Promise<string | null> {
  const storeUser = useStoreUser()
  const companyId = storeUser.companyData?.id ?? ''
  const extraMetadata = {
    idCompany: companyId,
    modelOwner: mo,
    id,
    video: true,
  }
  const path = 'public/misc/' + mo + '/' + id + '/video/'
  return await uploadFileToStorage( file, path, DBStorageType.MISC, mo, extraMetadata )
}

export async function uploadFile (
  file: File,
  modelOwner?: DBModelOwner,
  idRef?: string,
  extraMetadata?: any,
): Promise<string | null> {
  const storeUser = useStoreUser()
  const companyId = storeUser.companyData?.id ?? ''
  const mo = modelOwner ?? DBModelOwner.NOTDEFINED
  const idR = idRef && idRef !== '' ? idRef : 'NoRef'
  const path = 'company/' + companyId + '/file/' + mo + '/' + idR + '/'
  loggerLocal.info( 'uploadFile', file, path, mo, idRef, extraMetadata )
  //loggerLocal.info('uploadDocument', file, path)
  return await uploadFileToStorage( file, path, DBStorageType.COMPANY, mo, extraMetadata )
}

export async function deleteFile ( fileUrl: string, storageType: DBStorageType ): Promise<boolean> {
  const storeError = useStoreError()
  const session = getCurrentSession()
  const resSheckAuth = await checkAuth()
  if ( !resSheckAuth )
  {
    loggerLocal.info( 'resSheckAuth', resSheckAuth )
    return false
  }
  const storage =
    storageType == DBStorageType.USER
      ? storageUser
      : storageType == DBStorageType.COMPANY
        ? storageCompany
        : storageDefault
  loggerLocal.info( 'fileUrl', fileUrl, 'storage', storage )

  const storageRef = ref( storage, fileUrl )
  const metadata = await getMetadata( storageRef )
  loggerLocal.info( 'metadata', metadata )
  try
  {
    const res = await deleteObject( storageRef )
    loggerLocal.info( 'deleteObject', res )
    return true
  } catch ( error )
  {
    loggerLocal.error( 'deleteObject error', error )
    storeError.setError( i18nGlobal.t( 'error.storage' ), error )
    return false
  }
}

async function checkAuth (): Promise<boolean> {
  const storeUser = useStoreUser()
  const companyId = storeUser.companyData?.id ?? ''
  const userId = storeUser?.userData?.id ?? ''
  const providerId = storeUser?.userData?.idProvider ?? ''
  try
  {
    const companyAuthRef = doc( companyCollectionRef, companyId, GlbCompanyAuthCollectionName, providerId )
    const docSnap = await getDoc( companyAuthRef )
    if ( docSnap.exists() )
    {
      loggerLocal.info( 'checkAuth ok' )
      return true
    } else
    {
      const inputSetAuth: IOSetAuthRequest = {
        idCompany: companyId,
        idUser: userId,
      }
      const res = await be_setAuth( inputSetAuth )
      if ( res.result == DBRetCode.SUCCESS )
      {
        loggerLocal.info( 'checkAuth be_setAuth ok' )
        return true
      } else
      {
        loggerLocal.error( 'checkAuth error', res )
        const storeError = useStoreError()
        storeError.setError( i18nGlobal.t( 'error.userNotAuthorized' ), res )
        return false
      }
    }
  } catch ( error )
  {
    loggerLocal.error( 'checkAuth error', error )
    const storeError = useStoreError()
    storeError.setError( i18nGlobal.t( 'error.userNotAuthorized' ), error )
    return false
  }
}

export async function uploadFileBETOFIX ( file: File, path: string, fileType: '' ): Promise<string | null> {
  const storeUser = useStoreUser()
  try
  {
    const input: IOGetUploadUrlRequest = {
      contentType: file?.type ?? 'application/octet-stream',
      attachmentType: DBAttachmentType.ATTACHMENT,
      fileName: file?.name ?? 'file',
      contentLength: file.size,
      fileType: fileType,
      idCompany: storeUser.companyData?.id ?? '',
    }
    const res = await be_getUploadUrl( input )
    if ( res && res.result !== DBRetCode.ERROR )
    {
      const url2Uplad = res.uploadUrl
      const xhr = new XMLHttpRequest()
      xhr.open( 'PUT', url2Uplad )
      //xhr.upload.addEventListener('progress', e => progress(Math.round(e.loaded / e.total * 90) + 10))
      xhr.setRequestHeader( 'Content-Type', 'application/octet-stream' )
      await new Promise<void>( ( resolve, reject ) => {
        xhr.onload = e => ( xhr.status - 200 < 100 ? resolve() : reject( new Error( 'Failed to upload' ) ) )
        xhr.onerror = e => reject( new Error( 'Failed to upload' ) )
        xhr.send( file )
      } )
    }
  } catch ( error )
  {
    loggerLocal.error( 'uploadFile error', error )
    const storeError = useStoreError()
    storeError.setError( i18nGlobal.t( 'error.storage' ), error )
    return null
  }
  return null
}

/*export interface IGetAttachmentListRequest {
    idUser?: string
    idAttachment?: string
    idTimeTracking?: string
}
export interface IGetAttachmentListResponse {
    attachment: IntAttachmentData[]
    result?: DBRetCode
}*/

export async function getAttachmentList ( input: IOListAttachmentRequest ): Promise<IOListAttachmentResponse> {
  const storeUser = useStoreUser()
  const output: IOListAttachmentResponse = {
    attachment: [],
    result: DBRetCode.WARNING,
  }
  const inputList: IOListAttachmentRequest = {
    ...input,
    idRegistry: input.idRegistry,
    idAssignment: input.idAssignment,
    idDossier: input.idDossier,
    idUser: input.idUser,
    idAttachment: input.idAttachment,
    idLinkProcedure: input.idLinkProcedure,
    modelOwner: input.modelOwner,
  }
  try
  {
    const res = await be_listAttachment( inputList )
    if ( res && res.result !== DBRetCode.ERROR )
    {
      output.attachment = res.attachment
    } else
    {
      showErrorMessage( i18nGlobal.t( 'error.listStorage' ), res )
      /*const storeError = useStoreError()
            storeError.setError(i18nGlobal.t('error.listStorage'), res)*/
    }
    output.result = res?.result ?? DBRetCode.WARNING
  } catch ( error )
  {
    /*const storeError = useStoreError()
        storeError.setError(i18nGlobal.t('error.listStorage'), error)*/
    showErrorMessage( i18nGlobal.t( 'error.listStorage' ), error )
  }
  return output
}

export async function mutateAttachment (
  attachment: IntAttachmentData,
  mutationType: DBMutationType,
  storageType: DBStorageType,
  idCompanyOwner?: string,
): Promise<IOMutateAttachmentResponse> {
  const storeUser = useStoreUser()
  const storeError = useStoreError()
  const output: IOMutateAttachmentResponse = {
    result: DBRetCode.ERROR,
    attachment: attachment,
  }
  const inputMutate: IOMutateAttachmentRequest = {
    mutationType: mutationType,
    attachment: {
      ...attachment,
      idCompany: storeUser.companyData?.id ?? '',
      idUserIns: storeUser.userData?.id ?? '',
      idUserUpd: storeUser.userData?.id ?? '',
    },
    idCompanyOwner: idCompanyOwner,
  }
  try
  {
    const res = await be_mutateAttachment( inputMutate )
    if ( res && res.result !== DBRetCode.ERROR )
    {
      if ( mutationType == DBMutationType.DELETE )
      {
        //const storageRef = ref(storage, fileWithPath)
        //const resDel = await deleteFile(attachment?.fileBucketUrl ?? '', storageType)
        //await deleteObject(storageRef)
      }
    } else
    {
      storeError.setError( i18nGlobal.t( 'error.storage' ), res )
    }
    output.attachment = res.attachment
    output.result = res.result
  } catch ( error )
  {
    storeError.setError( i18nGlobal.t( 'error.storage' ), error )
  }

  return output
}
